'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
function minBy(items, getValue) {
    if (items.length === 0) {
        return undefined;
    }
    var minElement = items[0];
    var min = getValue(minElement);
    for(var i = 1; i < items.length; i++){
        var element = items[i];
        var value = getValue(element);
        if (value < min) {
            min = value;
            minElement = element;
        }
    }
    return minElement;
}
exports.minBy = minBy;
